// import {addFiles, deleteFile} from "@/api/file";
//
// export const uploadFile = async ({file}) => {
//   const params = new FormData();
//   params.append('attfile', file);
//   const uploaded = await addFiles({ file: params });
//   return {
//     name: file.name,
//     fid: uploaded.fid
//   }
// }
//
// export const cancelUploadFile = async ({fid}) => {
//   await deleteFile({ fid })
// }

export const uploadFile = async ({file}) => {
  const params = new FormData();
  params.append('contents', file);
  return params
}

export const saveDownloadFile = (response, defaultFileName = '', contentType = 'application/zip') => {
  const blob = response.data
  const contentDisposition = response.headers['content-disposition']
  const fileNameMatch = contentDisposition ? contentDisposition.match(/filename\*=UTF-8''(.+)/) : []
  const fileName = fileNameMatch.length > 1 ? decodeURI(fileNameMatch[1]) : defaultFileName

  if (window.navigator.msSaveOrOpenBlob) {
    // for IE,Edge
    window.navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    const url = URL.createObjectURL(new Blob([blob], { type: contentType }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    // link.revokeObjectURL()
  }
}
